import { useEffect, useRef, useState } from 'react';

export default function WhySection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="w-full py-20 md:py-32 px-4 md:px-8"
      style={{ backgroundColor: '#C2185B' }}
    >
      <div className="max-w-4xl mx-auto">
        <div
          className="text-center"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(40px)',
            transition: 'opacity 0.8s ease, transform 0.8s ease',
          }}
        >
          {/* 제목 */}
          <div className="mb-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ backgroundColor: '#00E5CC', color: '#0a2e2b' }}>
              <span className="w-2 h-2 rounded-full animate-pulse" style={{ backgroundColor: '#0a2e2b' }}></span>
              <span className="text-sm font-semibold tracking-wide" style={{ color: '#0a2e2b' }}>VISION</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl mb-6" style={{ color: '#ffffff', fontFamily: "'SeolripYooGeonWook', sans-serif", fontWeight: 'normal', letterSpacing: '-0.01em' }}>
              왜 한국교회사인가?
            </h2>
          </div>

          {/* 선언문 */}
          <div className="space-y-6 text-lg md:text-xl leading-relaxed" style={{ color: 'rgba(255,255,255,0.9)' }}>
            <p className="font-medium">
              저는 장로회신학대학원에서 역사신학을 공부하며 한 가지 확신을 갖게 되었습니다.
            </p>
            
            <p className="font-medium">
              한국교회의 놀라운 성장 뒤에는, 우리가 기억해야 할 사람들의 이야기가 있다는 것.
            </p>
            
            <p className="font-semibold text-2xl md:text-3xl mt-8" style={{ color: '#ffffff', fontFamily: "'Noto Serif KR', serif" }}>
              그 이야기를 발굴하고, 전하고,<br />
              다음 세대에 넘기는 것이 제 사명입니다.
            </p>
          </div>

          {/* 장식 요소 */}
          <div className="mt-12 flex items-center justify-center gap-3">
            <div className="w-16 h-0.5" style={{ backgroundColor: '#00E5CC' }}></div>
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#00E5CC' }}></div>
            <div className="w-16 h-0.5" style={{ backgroundColor: '#00E5CC' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
}